import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { useIntl } from 'react-intl';
import MediumTypography from '../../components/formlib/MediumTypography';
import { Activity } from '../../services/configApi/activitySheet/weeklyActivitySheetProvider';
import { FC } from 'react';
import { formatNumberToDecimalString } from '../../utils/utilities';

interface HoursOutTooltipProps {
  activity: Activity;
}

const HoursOutTooltip: FC<HoursOutTooltipProps> = ({ activity }) => {
  const rctl = useIntl();
  return (
    <Grid container padding={'8px'} display={'flex'} flexDirection={'column'}>
      {activity.bereavementHoursDec !== null &&
        activity.bereavementHoursDec !== 0 && (
          <Grid item>
            <Box display={'flex'}>
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'bereavementText',
                  defaultMessage: 'Bereavement',
                })}:`}
              />
              <MediumTypography
                className="pl-sm"
                label={
                  formatNumberToDecimalString(activity.bereavementHoursDec) ??
                  '0.00'
                }
              />
            </Box>
          </Grid>
        )}
      {activity.vacationHoursDec !== null &&
        activity.vacationHoursDec !== 0 && (
          <Grid item>
            <Box display={'flex'}>
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'vacationHoursText',
                  defaultMessage: 'Vacation',
                })}:`}
              />
              <MediumTypography
                className="pl-sm"
                label={
                  formatNumberToDecimalString(activity.vacationHoursDec) ??
                  '0.00'
                }
              />
            </Box>
          </Grid>
        )}
      {activity.etHoursDec !== null && activity.etHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'etHoursText',
                defaultMessage: 'Earned Time',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={formatNumberToDecimalString(activity.etHoursDec) ?? '0.00'}
            />
          </Box>
        </Grid>
      )}

      {activity.flexHoursDec !== null && activity.flexHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'flexHoursText',
                defaultMessage: 'Flex',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={
                formatNumberToDecimalString(activity.flexHoursDec) ?? '0.00'
              }
            />
          </Box>
        </Grid>
      )}

      {activity.holidayHoursDec !== null &&
        activity.holidayHoursDec !== 0 && (
          <Grid item>
            <Box display={'flex'}>
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'holidayTimeText',
                  defaultMessage: 'Holiday',
                })}:`}
              />
              <MediumTypography
                className="pl-sm"
                label={formatNumberToDecimalString(activity.holidayHoursDec) ?? '0.00'}
              />
            </Box>
          </Grid>
        )}

      {activity.sickHoursDec !== null && activity.sickHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'sickHrsText',
                defaultMessage: 'Sick/LTI',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={
                formatNumberToDecimalString(activity.sickHoursDec) ?? '0.00'
              }
            />
          </Box>
        </Grid>
      )}

      {activity.ltiHoursDec !== null && activity.ltiHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'ltiHoursText',
                defaultMessage: 'Sick Bank/Accumulated LTI',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={
                formatNumberToDecimalString(activity.ltiHoursDec) ?? '0.00'
              }
            />
          </Box>
        </Grid>
      )}

      {activity.profHoursDec !== null && activity.profHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'profHoursText',
                defaultMessage: 'Professional',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={
                formatNumberToDecimalString(activity.profHoursDec) ?? '0.00'
              }
            />
          </Box>
        </Grid>
      )}

      {activity.juryDutyHoursDec !== null &&
        activity.juryDutyHoursDec !== 0 && (
          <Grid item>
            <Box display={'flex'}>
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'juryDutyText',
                  defaultMessage: 'Jury Duty',
                })}:`}
              />
              <MediumTypography
                className="pl-sm"
                label={
                  formatNumberToDecimalString(activity.juryDutyHoursDec) ??
                  '0.00'
                }
              />
            </Box>
          </Grid>
        )}

      {activity.pfmlHoursDec !== null && activity.pfmlHoursDec !== 0 && (
        <Grid item>
          <Box display={'flex'}>
            <MediumTypography
              label={`${rctl.formatMessage({
                id: 'pfmlfmlaShortText',
                defaultMessage: 'PFML/FMLA',
              })}:`}
            />
            <MediumTypography
              className="pl-sm"
              label={
                formatNumberToDecimalString(activity.pfmlHoursDec) ?? '0.00'
              }
            />
          </Box>
        </Grid>
      )}

      {activity.hourlyTimeOffHoursDec !== null &&
        activity.hourlyTimeOffHoursDec !== 0 && (
          <Grid item>
            <Box display={'flex'}>
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'Hourlytimeoff',
                  defaultMessage: 'Hourly Time Off',
                })}:`}
              />
              <MediumTypography
                className="pl-sm"
                label={
                  formatNumberToDecimalString(activity.hourlyTimeOffHoursDec) ??
                  '0.00'
                }
              />
            </Box>
          </Grid>
        )}
    </Grid>
  );
};

export default HoursOutTooltip;
